// src/aritmetica/redondeo.ts
var ModoDeRedondeo = {
  /** 2,5 → 3 y −2,5 → −3. El habitual en el comercio argentino. */
  MITAD_AFUERA: "MITAD_AFUERA",
  /** 2,5 → 2 y 3,5 → 4. Bancario: reparte el sesgo de los empates. */
  MITAD_PAR: "MITAD_PAR",
  /** Trunca: 2,9 → 2 y −2,9 → −2. */
  HACIA_CERO: "HACIA_CERO",
  /** Siempre se aleja del cero: 2,1 → 3 y −2,1 → −3. */
  AFUERA: "AFUERA"
};
function dividirRedondeando(numerador, denominador, modo) {
  if (denominador === 0n) {
    throw new RangeError("Divisi\xF3n por cero");
  }
  const negativo = numerador < 0n !== denominador < 0n;
  const n = numerador < 0n ? -numerador : numerador;
  const d = denominador < 0n ? -denominador : denominador;
  const cociente = n / d;
  const resto = n % d;
  if (resto === 0n) {
    return negativo ? -cociente : cociente;
  }
  let ajuste;
  switch (modo) {
    case ModoDeRedondeo.HACIA_CERO:
      ajuste = 0n;
      break;
    case ModoDeRedondeo.AFUERA:
      ajuste = 1n;
      break;
    case ModoDeRedondeo.MITAD_AFUERA:
      ajuste = resto * 2n >= d ? 1n : 0n;
      break;
    case ModoDeRedondeo.MITAD_PAR: {
      const doble = resto * 2n;
      if (doble > d) ajuste = 1n;
      else if (doble < d) ajuste = 0n;
      else ajuste = cociente % 2n === 0n ? 0n : 1n;
      break;
    }
  }
  const resultado = cociente + ajuste;
  return negativo ? -resultado : resultado;
}

// src/errores/codigos.ts
var CodigoDeError = {
  // Aritmética y tipos de valor
  ERR_IMPORTE_INVALIDO: "ERR_IMPORTE_INVALIDO",
  ERR_IMPORTE_FUERA_DE_RANGO: "ERR_IMPORTE_FUERA_DE_RANGO",
  ERR_CANTIDAD_INVALIDA: "ERR_CANTIDAD_INVALIDA",
  ERR_CANTIDAD_FUERA_DE_RANGO: "ERR_CANTIDAD_FUERA_DE_RANGO",
  ERR_PRECISION_EXCEDIDA: "ERR_PRECISION_EXCEDIDA",
  ERR_MONEDAS_DISTINTAS: "ERR_MONEDAS_DISTINTAS",
  ERR_MONEDA_INVALIDA: "ERR_MONEDA_INVALIDA",
  ERR_COTIZACION_INVALIDA: "ERR_COTIZACION_INVALIDA",
  ERR_PORCENTAJE_INVALIDO: "ERR_PORCENTAJE_INVALIDO",
  ERR_PRORRATEO_SIN_PESOS: "ERR_PRORRATEO_SIN_PESOS",
  ERR_PRORRATEO_PESO_NEGATIVO: "ERR_PRORRATEO_PESO_NEGATIVO",
  // Acceso y contexto
  ERR_NO_AUTENTICADO: "ERR_NO_AUTENTICADO",
  ERR_CREDENCIALES_INVALIDAS: "ERR_CREDENCIALES_INVALIDAS",
  ERR_CUENTA_BLOQUEADA: "ERR_CUENTA_BLOQUEADA",
  ERR_CUENTA_SUSPENDIDA: "ERR_CUENTA_SUSPENDIDA",
  ERR_SESION_INVALIDA: "ERR_SESION_INVALIDA",
  ERR_SESION_VENCIDA: "ERR_SESION_VENCIDA",
  ERR_SESION_REUSADA: "ERR_SESION_REUSADA",
  ERR_SEGUNDO_FACTOR_REQUERIDO: "ERR_SEGUNDO_FACTOR_REQUERIDO",
  ERR_SEGUNDO_FACTOR_INVALIDO: "ERR_SEGUNDO_FACTOR_INVALIDO",
  ERR_SEGUNDO_FACTOR_YA_ACTIVO: "ERR_SEGUNDO_FACTOR_YA_ACTIVO",
  ERR_CONTRASENA_DEBIL: "ERR_CONTRASENA_DEBIL",
  ERR_INVITACION_INVALIDA: "ERR_INVITACION_INVALIDA",
  ERR_INVITACION_VENCIDA: "ERR_INVITACION_VENCIDA",
  ERR_INVITACION_YA_ACEPTADA: "ERR_INVITACION_YA_ACEPTADA",
  ERR_SIN_PERMISO: "ERR_SIN_PERMISO",
  ERR_EMPRESA_NO_RESUELTA: "ERR_EMPRESA_NO_RESUELTA",
  ERR_EMPRESA_SUSPENDIDA: "ERR_EMPRESA_SUSPENDIDA",
  ERR_COMERCIO_ACTIVO_NO_SE_BORRA: "ERR_COMERCIO_ACTIVO_NO_SE_BORRA",
  ERR_CONFIRMACION_NO_COINCIDE: "ERR_CONFIRMACION_NO_COINCIDE",
  ERR_CLAVE_ACTUAL_INCORRECTA: "ERR_CLAVE_ACTUAL_INCORRECTA",
  ERR_NO_ES_DUENIO: "ERR_NO_ES_DUENIO",
  ERR_SUCURSAL_FUERA_DE_ALCANCE: "ERR_SUCURSAL_FUERA_DE_ALCANCE",
  // Organización y localización
  ERR_PAIS_NO_SOPORTADO: "ERR_PAIS_NO_SOPORTADO",
  ERR_NO_DISPONIBLE_EN_EL_PAIS: "ERR_NO_DISPONIBLE_EN_EL_PAIS",
  ERR_IDENTIFICACION_FISCAL_INVALIDA: "ERR_IDENTIFICACION_FISCAL_INVALIDA",
  ERR_PARAMETRO_DESCONOCIDO: "ERR_PARAMETRO_DESCONOCIDO",
  ERR_PARAMETRO_INMUTABLE: "ERR_PARAMETRO_INMUTABLE",
  ERR_PARAMETRO_REQUIERE_CORTE: "ERR_PARAMETRO_REQUIERE_CORTE",
  ERR_VALOR_FUERA_DE_OPCIONES: "ERR_VALOR_FUERA_DE_OPCIONES",
  ERR_CODIGO_DUPLICADO: "ERR_CODIGO_DUPLICADO",
  ERR_EMPRESA_YA_REGISTRADA: "ERR_EMPRESA_YA_REGISTRADA",
  // Catálogo
  ERR_CODIGO_DE_BARRAS_EN_USO: "ERR_CODIGO_DE_BARRAS_EN_USO",
  ERR_PRECIO_NEGATIVO: "ERR_PRECIO_NEGATIVO",
  ERR_EXISTENCIA_INSUFICIENTE: "ERR_EXISTENCIA_INSUFICIENTE",
  ERR_COSTO_REQUERIDO: "ERR_COSTO_REQUERIDO",
  ERR_CANTIDAD_CERO: "ERR_CANTIDAD_CERO",
  ERR_DECIMALES_NO_ADMITIDOS: "ERR_DECIMALES_NO_ADMITIDOS",
  ERR_TURNO_YA_ABIERTO: "ERR_TURNO_YA_ABIERTO",
  ERR_TURNO_CERRADO: "ERR_TURNO_CERRADO",
  ERR_SIN_TURNO_ABIERTO: "ERR_SIN_TURNO_ABIERTO",
  ERR_VENTA_SIN_LINEAS: "ERR_VENTA_SIN_LINEAS",
  ERR_COBRO_NO_CUBRE_EL_TOTAL: "ERR_COBRO_NO_CUBRE_EL_TOTAL",
  ERR_ARTICULO_NO_VENDIBLE: "ERR_ARTICULO_NO_VENDIBLE",
  ERR_SIN_PRECIO: "ERR_SIN_PRECIO",
  ERR_CLAVE_DE_OPERACION_REUSADA: "ERR_CLAVE_DE_OPERACION_REUSADA",
  ERR_TERCERO_YA_REGISTRADO: "ERR_TERCERO_YA_REGISTRADO",
  ERR_TERCERO_NO_ES_PROVEEDOR: "ERR_TERCERO_NO_ES_PROVEEDOR",
  ERR_TERCERO_NO_ES_CLIENTE: "ERR_TERCERO_NO_ES_CLIENTE",
  ERR_VENTA_EN_CUENTA_SIN_CLIENTE: "ERR_VENTA_EN_CUENTA_SIN_CLIENTE",
  ERR_LIMITE_DE_CREDITO_SUPERADO: "ERR_LIMITE_DE_CREDITO_SUPERADO",
  ERR_MEDIO_DE_PAGO_NO_ES_PLATA: "ERR_MEDIO_DE_PAGO_NO_ES_PLATA",
  ERR_COBRO_SIN_MEDIOS: "ERR_COBRO_SIN_MEDIOS",
  ERR_IMPUTACION_INVALIDA: "ERR_IMPUTACION_INVALIDA",
  ERR_IMPUTACION_EXCEDE_EL_PENDIENTE: "ERR_IMPUTACION_EXCEDE_EL_PENDIENTE",
  ERR_IMPUTACION_EXCEDE_EL_COBRO: "ERR_IMPUTACION_EXCEDE_EL_COBRO",
  ERR_DEVOLUCION_EXCEDE_LO_VENDIDO: "ERR_DEVOLUCION_EXCEDE_LO_VENDIDO",
  ERR_DEVOLUCION_FUERA_DE_PLAZO: "ERR_DEVOLUCION_FUERA_DE_PLAZO",
  ERR_DEVOLUCION_SIN_CLIENTE: "ERR_DEVOLUCION_SIN_CLIENTE",
  ERR_MERCADERIA_YA_CONSUMIDA: "ERR_MERCADERIA_YA_CONSUMIDA",
  ERR_DOCUMENTO_CON_PAGOS: "ERR_DOCUMENTO_CON_PAGOS",
  ERR_RECEPCION_YA_FACTURADA: "ERR_RECEPCION_YA_FACTURADA",
  ERR_ORDEN_SIN_LINEAS: "ERR_ORDEN_SIN_LINEAS",
  ERR_COTIZACION_REQUERIDA: "ERR_COTIZACION_REQUERIDA",
  ERR_COTIZACION_DUPLICADA: "ERR_COTIZACION_DUPLICADA",
  ERR_SIN_COSTO_DE_REPOSICION: "ERR_SIN_COSTO_DE_REPOSICION",
  ERR_ESTADO_NO_ADMITE_LA_OPERACION: "ERR_ESTADO_NO_ADMITE_LA_OPERACION",
  ERR_RECEPCION_SIN_LINEAS: "ERR_RECEPCION_SIN_LINEAS",
  ERR_ORDEN_DE_OTRO_PROVEEDOR: "ERR_ORDEN_DE_OTRO_PROVEEDOR",
  ERR_FACTURA_SIN_LINEAS: "ERR_FACTURA_SIN_LINEAS",
  ERR_FACTURA_YA_REGISTRADA: "ERR_FACTURA_YA_REGISTRADA",
  ERR_IMPORTES_NO_CIERRAN: "ERR_IMPORTES_NO_CIERRAN",
  // Comprobantes e impuestos
  ERR_CONDICION_IVA_NO_EMITE: "ERR_CONDICION_IVA_NO_EMITE",
  ERR_CERTIFICADO_INVALIDO: "ERR_CERTIFICADO_INVALIDO",
  // Contabilidad
  ERR_CUENTA_CON_HIJAS: "ERR_CUENTA_CON_HIJAS",
  ERR_CUENTA_INACTIVA: "ERR_CUENTA_INACTIVA",
  ERR_CUENTA_CON_IMPUTACION: "ERR_CUENTA_CON_IMPUTACION",
  ERR_PERIODO_INVALIDO: "ERR_PERIODO_INVALIDO",
  ERR_EJERCICIOS_SE_SUPERPONEN: "ERR_EJERCICIOS_SE_SUPERPONEN",
  ERR_EJERCICIO_CERRADO: "ERR_EJERCICIO_CERRADO",
  ERR_EJERCICIO_ABIERTO: "ERR_EJERCICIO_ABIERTO",
  ERR_EJERCICIO_CON_POSTERIOR: "ERR_EJERCICIO_CON_POSTERIOR",
  ERR_SIN_EJERCICIO_ABIERTO: "ERR_SIN_EJERCICIO_ABIERTO",
  ERR_COLUMNAS_QUE_FALTAN: "ERR_COLUMNAS_QUE_FALTAN",
  ERR_CODIGO_REQUERIDO: "ERR_CODIGO_REQUERIDO",
  ERR_NOMBRE_REQUERIDO: "ERR_NOMBRE_REQUERIDO",
  ERR_UNIDAD_DESCONOCIDA: "ERR_UNIDAD_DESCONOCIDA",
  ERR_ARTICULO_NO_EXISTE: "ERR_ARTICULO_NO_EXISTE",
  ERR_LISTA_NO_EXISTE: "ERR_LISTA_NO_EXISTE",
  ERR_DEPOSITO_NO_EXISTE: "ERR_DEPOSITO_NO_EXISTE",
  ERR_IDENTIFICACION_INVALIDA: "ERR_IDENTIFICACION_INVALIDA",
  ERR_LOTE_YA_SE_USO: "ERR_LOTE_YA_SE_USO",
  ERR_LOTE_YA_REVERTIDO: "ERR_LOTE_YA_REVERTIDO",
  ERR_VALOR_NO_DISPONIBLE: "ERR_VALOR_NO_DISPONIBLE",
  ERR_CHEQUE_SIN_DATOS: "ERR_CHEQUE_SIN_DATOS",
  ERR_YA_CONCILIADO: "ERR_YA_CONCILIADO",
  ERR_DEPOSITO_YA_ACREDITADO: "ERR_DEPOSITO_YA_ACREDITADO",
  ERR_SIN_COMISIONES_PENDIENTES: "ERR_SIN_COMISIONES_PENDIENTES",
  ERR_PRODUCCION_NO_HABILITADA: "ERR_PRODUCCION_NO_HABILITADA",
  ERR_RECETA_CON_CICLO: "ERR_RECETA_CON_CICLO",
  ERR_JERARQUIA_CIRCULAR: "ERR_JERARQUIA_CIRCULAR",
  ERR_RECETA_VACIA: "ERR_RECETA_VACIA",
  ERR_ARMADO_YA_DESHECHO: "ERR_ARMADO_YA_DESHECHO",
  ERR_TIPO_INCOHERENTE: "ERR_TIPO_INCOHERENTE",
  ERR_LISTA_FIJADA_POR_EL_TIPO: "ERR_LISTA_FIJADA_POR_EL_TIPO",
  ERR_LISTA_NO_VIGENTE: "ERR_LISTA_NO_VIGENTE",
  ERR_LISTA_ASIGNADA: "ERR_LISTA_ASIGNADA",
  ERR_LISTA_PREDETERMINADA: "ERR_LISTA_PREDETERMINADA",
  ERR_TIPO_EXIGE_ORIGEN: "ERR_TIPO_EXIGE_ORIGEN",
  ERR_NUMERADOR_NO_RETROCEDE: "ERR_NUMERADOR_NO_RETROCEDE",
  ERR_NUMERADOR_DE_OTRO_PUNTO: "ERR_NUMERADOR_DE_OTRO_PUNTO",
  ERR_CAJA_FIJADA_POR_EL_TIPO: "ERR_CAJA_FIJADA_POR_EL_TIPO",
  ERR_CAMPO_INVALIDO: "ERR_CAMPO_INVALIDO",
  ERR_OPCION_EN_USO: "ERR_OPCION_EN_USO",
  ERR_TIPO_DE_ARCHIVO_NO_PERMITIDO: "ERR_TIPO_DE_ARCHIVO_NO_PERMITIDO",
  ERR_ARCHIVO_DEMASIADO_GRANDE: "ERR_ARCHIVO_DEMASIADO_GRANDE",
  ERR_ARCHIVO_SIN_CONTENIDO: "ERR_ARCHIVO_SIN_CONTENIDO",
  ERR_TIPO_NO_HABILITADO_PARA_EL_ROL: "ERR_TIPO_NO_HABILITADO_PARA_EL_ROL",
  ERR_SIN_REGLA_DE_IMPUTACION: "ERR_SIN_REGLA_DE_IMPUTACION",
  ERR_ASIENTO_NO_CUADRA: "ERR_ASIENTO_NO_CUADRA",
  ERR_ASIENTO_SIN_LINEAS: "ERR_ASIENTO_SIN_LINEAS",
  ERR_CUENTA_DE_AGRUPACION: "ERR_CUENTA_DE_AGRUPACION",
  // La caja clasificada (E37)
  ERR_CUENTA_CON_LIBRO_PROPIO: "ERR_CUENTA_CON_LIBRO_PROPIO",
  ERR_CONCEPTO_DE_CAJA_DUPLICADO: "ERR_CONCEPTO_DE_CAJA_DUPLICADO",
  ERR_CONCEPTO_DE_OTRO_SENTIDO: "ERR_CONCEPTO_DE_OTRO_SENTIDO",
  ERR_CONCEPTO_INACTIVO: "ERR_CONCEPTO_INACTIVO",
  ERR_MOVIMIENTO_YA_REVERTIDO: "ERR_MOVIMIENTO_YA_REVERTIDO",
  ERR_MOVIMIENTO_NO_SE_REVIERTE: "ERR_MOVIMIENTO_NO_SE_REVIERTE",
  // Accesos
  ERR_ROL_DE_DUENIO_INTOCABLE: "ERR_ROL_DE_DUENIO_INTOCABLE",
  ERR_ROL_DE_SISTEMA: "ERR_ROL_DE_SISTEMA",
  ERR_ROL_EN_USO: "ERR_ROL_EN_USO",
  ERR_ULTIMO_DUENIO: "ERR_ULTIMO_DUENIO",
  ERR_YA_ES_MIEMBRO: "ERR_YA_ES_MIEMBRO",
  // Genéricos de recurso
  ERR_NO_ENCONTRADO: "ERR_NO_ENCONTRADO",
  ERR_CONFLICTO: "ERR_CONFLICTO",
  ERR_ENTRADA_INVALIDA: "ERR_ENTRADA_INVALIDA",
  ERR_INTERNO: "ERR_INTERNO"
};

// src/errores/error-de-dominio.ts
var ErrorDeDominio = class extends Error {
  codigo;
  detalles;
  constructor(codigo, detalles = {}) {
    super(codigo);
    this.name = "ErrorDeDominio";
    this.codigo = codigo;
    this.detalles = detalles;
  }
};
function esErrorDeDominio(error) {
  return error instanceof ErrorDeDominio;
}

// src/aritmetica/decimal-fijo.ts
var POTENCIAS = [];
function potenciaDeDiez(exponente) {
  if (exponente < 0 || !Number.isInteger(exponente)) {
    throw new RangeError(`Exponente inv\xE1lido: ${exponente}`);
  }
  const cacheado = POTENCIAS[exponente];
  if (cacheado !== void 0) return cacheado;
  let valor = 1n;
  for (let i = 0; i < exponente; i += 1) valor *= 10n;
  POTENCIAS[exponente] = valor;
  return valor;
}
var LIMITE_DE_DIECIOCHO_DIGITOS = potenciaDeDiez(18);
var FORMATO_DECIMAL = /^([+-]?)(\d+)(?:\.(\d+))?$/;
function analizarTexto(texto, codigo) {
  const limpio = texto.trim();
  const coincidencia = FORMATO_DECIMAL.exec(limpio);
  if (coincidencia === null) {
    throw new ErrorDeDominio(codigo, { valor: texto });
  }
  return {
    negativo: coincidencia[1] === "-",
    enteros: coincidencia[2] ?? "0",
    decimales: coincidencia[3] ?? ""
  };
}
function brutoDesdeTexto(texto, escala, modo, codigo) {
  const { negativo, enteros, decimales } = analizarTexto(texto, codigo);
  if (decimales.length <= escala) {
    const rellenados = decimales.padEnd(escala, "0");
    const bruto = BigInt(enteros + rellenados);
    return negativo ? -bruto : bruto;
  }
  if (modo === void 0) {
    throw new ErrorDeDominio(CodigoDeError.ERR_PRECISION_EXCEDIDA, {
      valor: texto,
      escala,
      decimales: decimales.length
    });
  }
  const brutoAmplio = BigInt(enteros + decimales);
  const conSigno = negativo ? -brutoAmplio : brutoAmplio;
  return reescalar(conSigno, decimales.length, escala, modo);
}
function textoDesdeBruto(bruto, escala) {
  const negativo = bruto < 0n;
  const magnitud = (negativo ? -bruto : bruto).toString().padStart(escala + 1, "0");
  const corte = magnitud.length - escala;
  const enteros = magnitud.slice(0, corte);
  const signo = negativo ? "-" : "";
  return escala === 0 ? `${signo}${enteros}` : `${signo}${enteros}.${magnitud.slice(corte)}`;
}
function reescalar(bruto, escalaOrigen, escalaDestino, modo) {
  if (escalaDestino === escalaOrigen) return bruto;
  if (escalaDestino > escalaOrigen) {
    return bruto * potenciaDeDiez(escalaDestino - escalaOrigen);
  }
  return dividirRedondeando(bruto, potenciaDeDiez(escalaOrigen - escalaDestino), modo);
}
function multiplicar(brutoA, escalaA, brutoB, escalaB, escalaResultado, modo) {
  return reescalar(brutoA * brutoB, escalaA + escalaB, escalaResultado, modo);
}
function dividir(brutoA, escalaA, brutoB, escalaB, escalaResultado, modo) {
  if (brutoB === 0n) {
    throw new ErrorDeDominio(CodigoDeError.ERR_ENTRADA_INVALIDA, { motivo: "division_por_cero" });
  }
  const desplazamiento = escalaResultado + escalaB - escalaA;
  const numerador = desplazamiento >= 0 ? brutoA * potenciaDeDiez(desplazamiento) : brutoA;
  const denominador = desplazamiento >= 0 ? brutoB : brutoB * potenciaDeDiez(-desplazamiento);
  return dividirRedondeando(numerador, denominador, modo);
}
function verificarRango(bruto, codigo, escala) {
  const magnitud = bruto < 0n ? -bruto : bruto;
  if (magnitud >= LIMITE_DE_DIECIOCHO_DIGITOS) {
    throw new ErrorDeDominio(codigo, { escala });
  }
}

// src/dinero/moneda.ts
var FORMATO_ISO_4217 = /^[A-Z]{3}$/;
function codigoDeMoneda(valor) {
  const normalizado = valor.trim().toUpperCase();
  if (!FORMATO_ISO_4217.test(normalizado)) {
    throw new ErrorDeDominio(CodigoDeError.ERR_MONEDA_INVALIDA, { valor });
  }
  return normalizado;
}
var ARS = codigoDeMoneda("ARS");
var USD = codigoDeMoneda("USD");

// src/formato/numero.ts
function formatearTextoDecimal(texto, idioma, opciones) {
  return new Intl.NumberFormat(idioma, opciones).format(texto);
}

// src/medida/cantidad.ts
var Cantidad = class _Cantidad {
  constructor(bruto) {
    this.bruto = bruto;
  }
  bruto;
  static ESCALA = 3;
  static desdeBruto(bruto) {
    verificarRango(bruto, CodigoDeError.ERR_CANTIDAD_FUERA_DE_RANGO, _Cantidad.ESCALA);
    return new _Cantidad(bruto);
  }
  static desdeTexto(texto, modo) {
    return _Cantidad.desdeBruto(
      brutoDesdeTexto(texto, _Cantidad.ESCALA, modo, CodigoDeError.ERR_CANTIDAD_INVALIDA)
    );
  }
  /** Atajo para el caso más común: cantidades enteras. */
  static desdeEntero(valor) {
    if (!Number.isSafeInteger(valor)) {
      throw new ErrorDeDominio(CodigoDeError.ERR_CANTIDAD_INVALIDA, { valor: String(valor) });
    }
    return _Cantidad.desdeBruto(BigInt(valor) * potenciaDeDiez(_Cantidad.ESCALA));
  }
  static CERO = new _Cantidad(0n);
  sumar(otra) {
    return _Cantidad.desdeBruto(this.bruto + otra.bruto);
  }
  restar(otra) {
    return _Cantidad.desdeBruto(this.bruto - otra.bruto);
  }
  negada() {
    return _Cantidad.desdeBruto(-this.bruto);
  }
  /**
   * Cantidad por cantidad. **Tres unidades de un componente por cinco combos son quince.**
   *
   * Es la única operación de este archivo que puede perder precisión —el producto de dos números
   * de escala 3 tiene escala 6 y vuelve a 3—, así que el modo de redondeo es obligatorio: quien
   * multiplica decide qué hacer con lo que sobra, y no hay un default silencioso.
   */
  por(otra, modo) {
    return _Cantidad.desdeBruto(
      multiplicar(this.bruto, _Cantidad.ESCALA, otra.bruto, _Cantidad.ESCALA, _Cantidad.ESCALA, modo)
    );
  }
  esCero() {
    return this.bruto === 0n;
  }
  esPositiva() {
    return this.bruto > 0n;
  }
  esNegativa() {
    return this.bruto < 0n;
  }
  comparar(otra) {
    if (this.bruto < otra.bruto) return -1;
    if (this.bruto > otra.bruto) return 1;
    return 0;
  }
  igualA(otra) {
    return this.bruto === otra.bruto;
  }
  /** ¿Entra en una unidad de medida que admite `decimales` decimales? */
  tieneComoMuchoDecimales(decimales) {
    if (decimales >= _Cantidad.ESCALA) return true;
    const paso = potenciaDeDiez(_Cantidad.ESCALA - decimales);
    return this.bruto % paso === 0n;
  }
  /** Ajusta la cantidad a los decimales que admite la unidad de medida. */
  ajustarADecimales(decimales, modo) {
    if (decimales >= _Cantidad.ESCALA) return this;
    const reducido = reescalar(this.bruto, _Cantidad.ESCALA, decimales, modo);
    return _Cantidad.desdeBruto(reducido * potenciaDeDiez(_Cantidad.ESCALA - decimales));
  }
  aTexto() {
    return textoDesdeBruto(this.bruto, _Cantidad.ESCALA);
  }
  /**
   * Formato por configuración regional (D5): nunca se arma el número a mano.
   * Se formatea desde el texto y no desde un `number` para no pasar por coma flotante.
   */
  formatear(idioma, decimales = 2) {
    return formatearTextoDecimal(this.aTexto(), idioma, {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimales
    });
  }
  toJSON() {
    return this.aTexto();
  }
  toString() {
    return this.aTexto();
  }
};

// src/dinero/cotizacion.ts
var Cotizacion = class _Cotizacion {
  constructor(bruto) {
    this.bruto = bruto;
  }
  bruto;
  static ESCALA = 8;
  static desdeBruto(bruto) {
    if (bruto <= 0n) {
      throw new ErrorDeDominio(CodigoDeError.ERR_COTIZACION_INVALIDA, {
        valor: textoDesdeBruto(bruto, _Cotizacion.ESCALA)
      });
    }
    return new _Cotizacion(bruto);
  }
  static desdeTexto(texto, modo) {
    return _Cotizacion.desdeBruto(
      brutoDesdeTexto(texto, _Cotizacion.ESCALA, modo, CodigoDeError.ERR_COTIZACION_INVALIDA)
    );
  }
  /** La cotización de una moneda contra sí misma. */
  static UNO = new _Cotizacion(100000000n);
  esUno() {
    return this.bruto === _Cotizacion.UNO.bruto;
  }
  aTexto() {
    return textoDesdeBruto(this.bruto, _Cotizacion.ESCALA);
  }
  toJSON() {
    return this.aTexto();
  }
  toString() {
    return this.aTexto();
  }
};

// src/dinero/porcentaje.ts
var Porcentaje = class _Porcentaje {
  constructor(bruto) {
    this.bruto = bruto;
  }
  bruto;
  static ESCALA = 4;
  static desdeBruto(bruto) {
    return new _Porcentaje(bruto);
  }
  static desdeTexto(texto, modo) {
    return new _Porcentaje(
      brutoDesdeTexto(texto, _Porcentaje.ESCALA, modo, CodigoDeError.ERR_PORCENTAJE_INVALIDO)
    );
  }
  static CERO = new _Porcentaje(0n);
  esCero() {
    return this.bruto === 0n;
  }
  /**
   * Cuál es mayor. Hacía falta desde que un artículo puede estar en varios rubros y la comisión
   * toma la regla que más paga: sin esto, comparar dos porcentajes exigía sacarlos a texto o a
   * número, y las dos formas mienten en el borde.
   */
  comparar(otro) {
    if (this.bruto === otro.bruto) return 0;
    return this.bruto > otro.bruto ? 1 : -1;
  }
  aTexto() {
    return textoDesdeBruto(this.bruto, _Porcentaje.ESCALA);
  }
  formatear(idioma, decimales = 2) {
    return formatearTextoDecimal(textoDesdeBruto(this.bruto, _Porcentaje.ESCALA + 2), idioma, {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: decimales
    });
  }
  toJSON() {
    return this.aTexto();
  }
  toString() {
    return this.aTexto();
  }
};

// src/dinero/importe.ts
var Importe = class _Importe {
  constructor(bruto, moneda) {
    this.bruto = bruto;
    this.moneda = moneda;
  }
  bruto;
  moneda;
  static ESCALA = 4;
  static desdeBruto(bruto, moneda) {
    verificarRango(bruto, CodigoDeError.ERR_IMPORTE_FUERA_DE_RANGO, _Importe.ESCALA);
    return new _Importe(bruto, moneda);
  }
  static desdeTexto(texto, moneda, modo) {
    return _Importe.desdeBruto(
      brutoDesdeTexto(texto, _Importe.ESCALA, modo, CodigoDeError.ERR_IMPORTE_INVALIDO),
      moneda
    );
  }
  /** Para importes redondos: `Importe.desdeEntero(1500, ARS)` es $ 1.500,00. */
  static desdeEntero(valor, moneda) {
    if (!Number.isSafeInteger(valor)) {
      throw new ErrorDeDominio(CodigoDeError.ERR_IMPORTE_INVALIDO, { valor: String(valor) });
    }
    return _Importe.desdeBruto(BigInt(valor) * potenciaDeDiez(_Importe.ESCALA), moneda);
  }
  static cero(moneda) {
    return new _Importe(0n, moneda);
  }
  exigirMismaMoneda(otro) {
    if (this.moneda !== otro.moneda) {
      throw new ErrorDeDominio(CodigoDeError.ERR_MONEDAS_DISTINTAS, {
        esperada: this.moneda,
        recibida: otro.moneda
      });
    }
  }
  sumar(otro) {
    this.exigirMismaMoneda(otro);
    return _Importe.desdeBruto(this.bruto + otro.bruto, this.moneda);
  }
  restar(otro) {
    this.exigirMismaMoneda(otro);
    return _Importe.desdeBruto(this.bruto - otro.bruto, this.moneda);
  }
  negado() {
    return _Importe.desdeBruto(-this.bruto, this.moneda);
  }
  valorAbsoluto() {
    return this.bruto < 0n ? this.negado() : this;
  }
  esCero() {
    return this.bruto === 0n;
  }
  esPositivo() {
    return this.bruto > 0n;
  }
  esNegativo() {
    return this.bruto < 0n;
  }
  comparar(otro) {
    this.exigirMismaMoneda(otro);
    if (this.bruto < otro.bruto) return -1;
    if (this.bruto > otro.bruto) return 1;
    return 0;
  }
  igualA(otro) {
    return this.moneda === otro.moneda && this.bruto === otro.bruto;
  }
  /** Precio unitario por cantidad. El producto se calcula exacto y se redondea una vez. */
  porCantidad(cantidad, modo) {
    return _Importe.desdeBruto(
      multiplicar(
        this.bruto,
        _Importe.ESCALA,
        cantidad.bruto,
        Cantidad.ESCALA,
        _Importe.ESCALA,
        modo
      ),
      this.moneda
    );
  }
  /** Reparte un importe entre una cantidad: sirve para costo unitario de una producción. */
  entreCantidad(cantidad, modo) {
    if (cantidad.esCero()) {
      throw new ErrorDeDominio(CodigoDeError.ERR_ENTRADA_INVALIDA, {
        motivo: "division_por_cantidad_cero"
      });
    }
    return _Importe.desdeBruto(
      dividir(this.bruto, _Importe.ESCALA, cantidad.bruto, Cantidad.ESCALA, _Importe.ESCALA, modo),
      this.moneda
    );
  }
  /** La **parte** que representa el porcentaje. El 21 % de $ 100 es $ 21. */
  porcentaje(porcentaje, modo) {
    return _Importe.desdeBruto(
      multiplicar(
        this.bruto,
        _Importe.ESCALA,
        porcentaje.bruto,
        Porcentaje.ESCALA + 2,
        _Importe.ESCALA,
        modo
      ),
      this.moneda
    );
  }
  /** El importe más el porcentaje. Sumarle el IVA a un neto. */
  masPorcentaje(porcentaje, modo) {
    return this.sumar(this.porcentaje(porcentaje, modo));
  }
  /** El importe menos el porcentaje. Una bonificación. */
  menosPorcentaje(porcentaje, modo) {
    return this.restar(this.porcentaje(porcentaje, modo));
  }
  /**
   * Convierte a otra moneda con una cotización explícita.
   * Quien llama es responsable de persistir la cotización aplicada junto al importe
   * convertido: es el invariante INV-15.
   */
  convertirA(moneda, cotizacion, modo) {
    return _Importe.desdeBruto(
      multiplicar(
        this.bruto,
        _Importe.ESCALA,
        cotizacion.bruto,
        Cotizacion.ESCALA,
        _Importe.ESCALA,
        modo
      ),
      moneda
    );
  }
  /**
   * Redondea a menos decimales conservando la escala interna: el total de un ticket
   * que se cobra al peso sigue siendo un importe de escala 4, pero termina en ,0000.
   */
  redondearA(decimales, modo) {
    if (decimales >= _Importe.ESCALA) return this;
    const reducido = reescalar(this.bruto, _Importe.ESCALA, decimales, modo);
    return _Importe.desdeBruto(reducido * potenciaDeDiez(_Importe.ESCALA - decimales), this.moneda);
  }
  aTexto() {
    return textoDesdeBruto(this.bruto, _Importe.ESCALA);
  }
  /**
   * Formato por configuración regional (D5). Se formatea desde el texto exacto y no
   * desde un `number`, para no perder precisión en el último paso.
   */
  formatear(idioma, decimales = 2) {
    return formatearTextoDecimal(this.aTexto(), idioma, {
      style: "currency",
      currency: this.moneda,
      minimumFractionDigits: decimales,
      maximumFractionDigits: decimales
    });
  }
  toJSON() {
    return { moneda: this.moneda, importe: this.aTexto() };
  }
  toString() {
    return `${this.moneda} ${this.aTexto()}`;
  }
  /** Suma una lista exigiendo moneda única. La lista vacía necesita saber la moneda. */
  static sumarTodos(importes, moneda) {
    return importes.reduce(
      (acumulado, actual) => acumulado.sumar(actual),
      _Importe.cero(moneda)
    );
  }
};

// src/dinero/prorrateo.ts
function prorratear(total, pesos, opciones = {}) {
  if (pesos.length === 0) return [];
  let suma = 0n;
  for (const peso of pesos) {
    if (peso < 0n) {
      throw new ErrorDeDominio(CodigoDeError.ERR_PRORRATEO_PESO_NEGATIVO);
    }
    suma += peso;
  }
  if (suma === 0n) {
    throw new ErrorDeDominio(CodigoDeError.ERR_PRORRATEO_SIN_PESOS);
  }
  const decimales = opciones.decimales ?? Importe.ESCALA;
  const paso = decimales >= Importe.ESCALA ? 1n : potenciaDeDiez(Importe.ESCALA - decimales);
  if (total.bruto % paso !== 0n) {
    throw new ErrorDeDominio(CodigoDeError.ERR_ENTRADA_INVALIDA, {
      motivo: "total_no_redondeado",
      decimales
    });
  }
  const negativo = total.bruto < 0n;
  const magnitud = (negativo ? -total.bruto : total.bruto) / paso;
  const partes = new Array(pesos.length).fill(0n);
  const restos = [];
  let asignado = 0n;
  for (let i = 0; i < pesos.length; i += 1) {
    const peso = pesos[i] ?? 0n;
    const producto = magnitud * peso;
    const base = producto / suma;
    partes[i] = base;
    restos.push({ indice: i, resto: producto % suma });
    asignado += base;
  }
  let sobrante = magnitud - asignado;
  restos.sort((a, b) => {
    if (a.resto === b.resto) return a.indice - b.indice;
    return a.resto > b.resto ? -1 : 1;
  });
  for (const { indice } of restos) {
    if (sobrante <= 0n) break;
    partes[indice] = (partes[indice] ?? 0n) + 1n;
    sobrante -= 1n;
  }
  return partes.map((parte) => {
    const conPaso = parte * paso;
    return Importe.desdeBruto(negativo ? -conPaso : conPaso, total.moneda);
  });
}

// src/dinero/descuentos.ts
function aplicarDescuentosEnCascada(base, descuentos, modo) {
  return descuentos.reduce(
    (parcial, descuento) => descuento.esCero() ? parcial : parcial.menosPorcentaje(descuento, modo),
    base
  );
}

// src/precios/escalas.ts
function descuentoPorCantidad(escalas, cantidad) {
  let elegido = null;
  for (const escala of escalas) {
    if (compararDecimales(cantidad, escala.desdeCantidad) < 0) continue;
    if (elegido === null || compararDecimales(escala.desdeCantidad, elegido.desdeCantidad) > 0) {
      elegido = escala;
    }
  }
  return elegido?.porcentaje ?? null;
}
function compararDecimales(a, b) {
  const [enteraA = "0", fraccionA = ""] = a.trim().split(".");
  const [enteraB = "0", fraccionB = ""] = b.trim().split(".");
  const largo = Math.max(fraccionA.length, fraccionB.length);
  const izquierda = BigInt(`${enteraA}${fraccionA.padEnd(largo, "0")}`);
  const derecha = BigInt(`${enteraB}${fraccionB.padEnd(largo, "0")}`);
  if (izquierda === derecha) return 0;
  return izquierda < derecha ? -1 : 1;
}

// src/impuestos/iva.ts
function separarIvaDelFinal(final, alicuota, modo) {
  if (alicuota.esCero()) return { neto: final, iva: Importe.cero(final.moneda) };
  const coeficiente = 1000000n + alicuota.bruto;
  const neto = Importe.desdeBruto(
    dividir(final.bruto, Importe.ESCALA, coeficiente, 6, Importe.ESCALA, modo),
    final.moneda
  );
  return { neto, iva: final.restar(neto) };
}
function agruparIvaPorAlicuota(lineas, moneda) {
  const porCodigo = /* @__PURE__ */ new Map();
  for (const linea of lineas) {
    const acumulado = porCodigo.get(linea.codigo) ?? {
      neto: Importe.cero(moneda),
      iva: Importe.cero(moneda)
    };
    porCodigo.set(linea.codigo, {
      neto: acumulado.neto.sumar(linea.neto),
      iva: acumulado.iva.sumar(linea.iva)
    });
  }
  return [...porCodigo.entries()].map(([codigo, importes]) => ({ codigo, ...importes })).sort((a, b) => a.codigo.localeCompare(b.codigo));
}
function desglosarParaImprimir(partes, total, decimales = 2) {
  if (partes.length === 0) return [];
  const impreso = total.redondearA(decimales, ModoDeRedondeo.MITAD_AFUERA);
  const importes = partes.map((parte) => parte.neto.sumar(parte.iva));
  const repartidos = importes.every((importe) => importe.esCero()) ? importes : prorratear(
    impreso,
    importes.map((importe) => importe.bruto),
    { decimales }
  );
  return partes.map((parte, indice) => {
    const delGrupo = repartidos[indice] ?? Importe.cero(total.moneda);
    const iva = parte.iva.redondearA(decimales, ModoDeRedondeo.MITAD_AFUERA);
    const ivaImpreso = iva.comparar(delGrupo) > 0 ? delGrupo : iva;
    return { codigo: parte.codigo, neto: delGrupo.restar(ivaImpreso), iva: ivaImpreso };
  });
}

// src/catalogo/variantes.ts
function limpiar(valor) {
  const limpio = valor?.trim() ?? "";
  return limpio === "" ? null : limpio;
}
function sufijo(talle, color) {
  return [talle, color].filter((parte) => parte !== null).map((parte) => parte.toUpperCase().replace(/\s+/g, "")).join("-");
}
function combinacionesDeVariantes(codigoDelArticulo, pedidas) {
  const normalizadas = pedidas.map((pedida) => ({ talle: limpiar(pedida.talle), color: limpiar(pedida.color) })).filter((pedida) => pedida.talle !== null || pedida.color !== null);
  if (normalizadas.length === 0) {
    return [{ codigo: codigoDelArticulo, talle: null, color: null, esUnica: true }];
  }
  const vistas = /* @__PURE__ */ new Set();
  const resultado = [];
  for (const { talle, color } of normalizadas) {
    const clave = `${talle ?? ""}|${color ?? ""}`.toUpperCase();
    if (vistas.has(clave)) continue;
    vistas.add(clave);
    resultado.push({
      codigo: `${codigoDelArticulo}-${sufijo(talle, color)}`,
      talle,
      color,
      esUnica: false
    });
  }
  return resultado;
}
function cruzarTallesYColores(talles, colores) {
  const conTalle = talles.map(limpiar).filter((valor) => valor !== null);
  const conColor = colores.map(limpiar).filter((valor) => valor !== null);
  if (conTalle.length === 0 && conColor.length === 0) return [];
  if (conColor.length === 0) return conTalle.map((talle) => ({ talle }));
  if (conTalle.length === 0) return conColor.map((color) => ({ color }));
  return conTalle.flatMap((talle) => conColor.map((color) => ({ talle, color })));
}
function separarPorComas(texto) {
  return texto.split(",").map((parte) => parte.trim()).filter((parte) => parte !== "");
}

// src/ventas/calculo.ts
function calcularLinea(linea, modo) {
  const bruto = linea.precioUnitario.porCantidad(linea.cantidad, modo);
  const importe = aplicarDescuentosEnCascada(bruto, linea.descuentos, modo);
  return { bruto, importe, descuento: bruto.restar(importe) };
}
function calcularTotales(lineas, opciones) {
  const cero = Importe.cero(opciones.moneda.moneda);
  const subtotal = lineas.reduce((suma, linea) => suma.sumar(linea.importe), cero);
  const descuentoTotal = lineas.reduce((suma, linea) => suma.sumar(linea.descuento), cero);
  if (!opciones.hayEfectivo) {
    return { subtotal, descuentoTotal, redondeo: cero, total: subtotal };
  }
  const total = subtotal.redondearA(opciones.decimalesDelEfectivo, opciones.modo);
  return { subtotal, descuentoTotal, redondeo: total.restar(subtotal), total };
}
var DECIMALES_DEL_EFECTIVO = 0;
var MODO_DE_REDONDEO_DEL_EFECTIVO = ModoDeRedondeo.MITAD_AFUERA;

// src/planilla/csv.ts
function detectarSeparador(texto) {
  const primera = texto.split(/\r?\n/, 1)[0] ?? "";
  const cuantos = (cual) => primera.split(cual).length - 1;
  const candidatos = [
    { separador: ";", veces: cuantos(";") },
    { separador: ",", veces: cuantos(",") },
    { separador: "	", veces: cuantos("	") }
  ];
  const mejor = candidatos.reduce((uno, otro) => otro.veces > uno.veces ? otro : uno);
  return mejor.veces === 0 ? ";" : mejor.separador;
}
function leerPlanilla(texto, separador = detectarSeparador(texto)) {
  const limpio = texto.startsWith("\uFEFF") ? texto.slice(1) : texto;
  const filas = [];
  let celdas = [];
  let celda = "";
  let entreComillas = false;
  let linea = 1;
  let hayContenido = false;
  const cerrarCelda = () => {
    celdas.push(celda.trim());
    celda = "";
  };
  const cerrarFila = () => {
    cerrarCelda();
    if (hayContenido) filas.push({ linea, celdas });
    celdas = [];
    hayContenido = false;
  };
  for (let posicion = 0; posicion < limpio.length; posicion += 1) {
    const caracter = limpio[posicion] ?? "";
    if (entreComillas) {
      if (caracter === '"') {
        if (limpio[posicion + 1] === '"') {
          celda += '"';
          posicion += 1;
        } else {
          entreComillas = false;
        }
      } else {
        celda += caracter;
        hayContenido = true;
      }
      continue;
    }
    if (caracter === '"' && celda.trim() === "") {
      entreComillas = true;
      hayContenido = true;
    } else if (caracter === separador) {
      cerrarCelda();
    } else if (caracter === "\n") {
      cerrarFila();
      linea += 1;
    } else if (caracter === "\r") {
    } else {
      celda += caracter;
      if (caracter.trim() !== "") hayContenido = true;
    }
  }
  cerrarFila();
  const [encabezado, ...cuerpo] = filas;
  return {
    encabezados: (encabezado?.celdas ?? []).map((uno) => uno.toLowerCase()),
    filas: cuerpo,
    separador
  };
}
function normalizarEncabezado(texto) {
  return texto.normalize("NFD").replaceAll(/[̀-ͯ]/g, "").toLowerCase().replaceAll(/[^a-z0-9]/g, "");
}

// src/planilla/numero.ts
function leerNumeroDePlanilla(texto) {
  const limpio = texto.replaceAll(/[^\d.,-]/g, "");
  if (limpio === "" || limpio === "-") return null;
  let normalizado = limpio;
  if (normalizado.includes(",")) {
    normalizado = normalizado.replaceAll(".", "").replace(",", ".");
  } else if (/\.\d{3}$/.test(normalizado)) {
    normalizado = normalizado.replaceAll(".", "");
  }
  if (!/^-?\d+(\.\d+)?$/.test(normalizado)) return null;
  return normalizado;
}
function leerFechaDePlanilla(texto) {
  const limpio = texto.trim();
  if (limpio === "") return null;
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(limpio);
  if (iso !== null) return fechaValida(iso[1] ?? "", iso[2] ?? "", iso[3] ?? "");
  const conBarras = /^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{2,4})$/.exec(limpio);
  if (conBarras === null) return null;
  const dia = (conBarras[1] ?? "").padStart(2, "0");
  const mes = (conBarras[2] ?? "").padStart(2, "0");
  const anio = conBarras[3] ?? "";
  return fechaValida(anio.length === 2 ? `20${anio}` : anio, mes, dia);
}
function fechaValida(anio, mes, dia) {
  const numeroDeMes = Number(mes);
  const numeroDeDia = Number(dia);
  if (numeroDeMes < 1 || numeroDeMes > 12 || numeroDeDia < 1 || numeroDeDia > 31) return null;
  return `${anio}-${mes}-${dia}`;
}
export {
  ARS,
  Cantidad,
  CodigoDeError,
  Cotizacion,
  DECIMALES_DEL_EFECTIVO,
  ErrorDeDominio,
  Importe,
  LIMITE_DE_DIECIOCHO_DIGITOS,
  MODO_DE_REDONDEO_DEL_EFECTIVO,
  ModoDeRedondeo,
  Porcentaje,
  USD,
  agruparIvaPorAlicuota,
  aplicarDescuentosEnCascada,
  calcularLinea,
  calcularTotales,
  codigoDeMoneda,
  combinacionesDeVariantes,
  cruzarTallesYColores,
  descuentoPorCantidad,
  desglosarParaImprimir,
  detectarSeparador,
  dividirRedondeando,
  esErrorDeDominio,
  leerFechaDePlanilla,
  leerNumeroDePlanilla,
  leerPlanilla,
  normalizarEncabezado,
  potenciaDeDiez,
  prorratear,
  separarIvaDelFinal,
  separarPorComas,
  textoDesdeBruto
};
//# sourceMappingURL=index.js.map